import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import TestView from "./test_view";
import AppController, { AnalyticsEvent, AnalyticsParam } from "../../../../sdk/app_controller";
import AppData from "../../../public/const/app_data";
import EventManager from "../../../../manager/event_manager";
import LoaclStorage from "../../../../manager/local_storage";
import ModuleManager from "../../../../framework/core/module_manager";
import SceneManager from "../../../../manager/scene_manager";
import { GameManager } from "../../../../manager/game_manager";
import Utility from "../../../../utility/utility";
import GoogleBillingController, { PurchaseState } from "../../../../sdk/googlebilling_controller";
import ModelData from "../../../public/model_data";
import LogManager from '../../../../manager/log_manager';
import IAPController from "../../../../sdk/iap_controller";
import GameUtil from "../../../../utility/game_util";
import { symlinkSync } from "fs";
import { Game } from "../../../bjl/net/proto/bjl_game";

const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("Test")
export default class Test extends ModuleBase<TestView, null> {

    isClick = false
    _sourceNode: cc.Node = null
    _userDemoEnvi: number = 0
    _clickTimes = 0
    _loginMode = 0
    constructor() {
        super();
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/test/test";
        this.viewType = TestView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseBg = true
        this.needViewBaseTitleBg = true
        this.needViewBaseCloseBtn = true
    }

    @bindButtonClickEvent("closeBtn")
    onButtonClose() {
        this.hide()
    }
    @bindButtonClickEvent("btnTest1")
    onButtonTest1() {
        let str = this.view.editBox.string
        cc.log("复制文字到剪切板：", str)
        AppController.instance.copyTextToClipboard(str)
        AppController.instance.setOrientation(2)
        AppController.instance.setOrientation(1)
    }
    @bindButtonClickEvent("btnTest2")
    onButtonTest2() {
        cc.log("从剪切板获取文字")
        let str = AppController.instance.getTextFromClipboard()
        this.view.text.string = str
    }
    @bindButtonClickEvent("btnTest3")
    onButtonTest3() {
        cc.log("打开相册")
        AppController.instance.openAlbum(0, 0)
    }
    @bindButtonClickEvent("btnTest4")
    onButtonTest4() {
        cc.log("打开相机")
        AppController.instance.openCamera(0, 0)
        // this.view.testNode.active =false;
    }
    @bindButtonClickEvent("btnTest5")
    onButtonTest5() {
        cc.log("截图并保存相册")
        this.captureScreen(this.view.node, null)
    }
    @bindButtonClickEvent("btnTest6")
    onButtonTest6() {
        cc.log("获取openinstall数据")
        AppController.instance.requestOpeninstallData()
        // Utility.reportEffect("testPoint")
    }
    @bindButtonClickEvent("btnTest7")
    onButtonTest7() {
        cc.log("打开微信")
        AppController.instance.startApp("weixin://")
    }
    @bindButtonClickEvent("btnTest8")
    onButtonTest8() {
        cc.log("微信是否存在")
        this.view.text.string = AppData.devicesModel
        LogManager.instance.setUid(ModelData.instance.roleData.id)
        LogManager.instance.upload_log_file()
    }
    @bindButtonClickEvent("btnTestRest")
    btnTestRest() {
        AppData.setServerByData(0)
        if (CC_JSB) {
            jsb.fileUtils.removeDirectory(jsb.fileUtils.getWritablePath() + 'remote-assets');
        } 
        GameManager.reboot()
        // AppController.instance.installApk("/storage/emulated/0/dayingjia.apk")


    }
    @bindButtonClickEvent("VerifyBtn")
    onButtonVerifyBtn() {
        if (this.view.verifyBox.string == "20191102") {
            this.view.verifyNode.active = false
            this.view.testNode.active = true
            this.view.messageNode.active = true
            LoaclStorage.setNumber("__isDevelopTestMode", 2)   //开发者模式   
        } else if (this.view.verifyBox.string == "20191201") {
            this.view.verifyNode.active = false
            this.view.demoNode.active = true
            this.view.messageNode.active = true
            LoaclStorage.setNumber("__isDevelopTestMode", 1)   //体验模式
        }
    }

    @bindButtonClickEvent("btnTest9")
    onButtonTest9() {
        cc.log("连接测试服")
        this._sourceNode = this.view.testNode
        this._userDemoEnvi = 2
        this._loginMode = 2
        this.serverInput()
    }
    @bindButtonClickEvent("btnTest10")
    onButtonTest10() {
        cc.log("连接体验服")
        this._sourceNode = this.view.testNode
        this._userDemoEnvi = 1
        this._loginMode = 1
        this.serverInput()
    }
    @bindButtonClickEvent("btnTestUploadLogFile")
    onButtonTestUploadLogFile() {
        // cc.log("连接正式服")
        LogManager.instance.uploadLogFile(() => {
            ModuleManager.instance.toast("日志上传成功")
        })
    }
    @bindButtonClickEvent("btnTest12")
    onButtonTest12() {
        this.copyToken()
        // this.view.nullNode.active = false
        
        // LogManager.instance.compress_log_file()
    }
    @bindButtonClickEvent("btnTest13")
    onButtonTest13() {
        cc.log("震动")
        if (CC_JSB) {
            jsb.Device.vibrate(2)
        }
        this.view.text.string = navigator.userAgent
        AppController.instance.copyTextToClipboard(navigator.userAgent)
        // window.location.href = "line://ti/p/@238hjrcl"//"line://home/public/main?id={238hjrcl}"
        // cc.sys.openURL("https://test-client-web.oss-cn-shenzhen.aliyuncs.com/bigwinner.mobileconfig")
        LogManager.instance.clear_expired_log()
        LoaclStorage.setString("__SkipCheckGame", AppData.appVersion)
        LoaclStorage.setString("__SkipCheckGameForce", "")
        GameManager.reboot()
    }
    @bindButtonClickEvent("btnTest14")
    onButtonTest14() {
        cc.log("测试")
        // let ip = AppController.instance.getIpByHostAsync("api." + AppData.constHostProduct)
        // AppController.instance.getIpsByHostAsync("api." + AppData.constHostProduct)
        // let ls = AppController.instance.getLaunchUrlParameter()
        // this.view.text.string = ls

        // let param: AnalyticsParam = {
        //     item_id: "123",
        //     item_name: "test_item"
        // }
        // AppController.instance.trackerEvent(AnalyticsEvent.ADD_PAYMENT_INFO, param)
        // LogManager.instance.log("test1 \n test\n")
        // let list = jsb.fileUtils.listFiles(jsb.fileUtils.getWritablePath() + 'log')
        // let size = list.length
        // cc.log("log文件夹有：",size)
        // for (let index = 0; index < list.length; index++){
        //     cc.log("filelist:",list[index])
        // }
        // jsb.fileUtils.appendStringToFile("test1 \n test\n", jsb.fileUtils.getWritablePath() + 'log/test.txt');
        // AppController.instance.GetInstallReferrer()
        // LoaclStorage.setString("__SkipCheckGame", "")
        // LoaclStorage.setString("__SkipCheckGameForce", "1")
        // AppData.startCheckGame = true
        // GameManager.reboot()
        AppController.instance.setFBSDKAppEvents("fb_mobile_complete_registration", {"fb_registration_method":"facebook", "currency":"THB"})
    }
    @bindButtonClickEvent("btnDemo1")
    onButtonDemo1() {
        cc.log("连接体验服")
        this._sourceNode = this.view.demoNode
        this._userDemoEnvi = 1
        this._loginMode = 1
        this.serverInput()
    }
    @bindButtonClickEvent("btnDemo2")
    onButtonDemo2() {
        cc.log("连接正式服")
        this.gobackLogin(0)
    }
    @bindButtonClickEvent("btnDemo3", true)
    onButtonDemo3() {
        if (this._clickTimes > 5) {
            this.view.verifyNode.active = true
            this.view.testNode.active = false
            this.view.demoNode.active = false
        }
        this._clickTimes += 1
    }
    @bindButtonClickEvent("ServerBtn")
    onButtonServer() {
        this.verifyServerUrl(this.view.serverBox.string)
    }
    @bindButtonClickEvent("ServerPlusBtn")
    onButtonServerSave() {
        this.saveServerUrl(this.view.serverBox.string)
    }
    @bindButtonClickEvent("CancelBtn")
    onButtonCancel() {
        this.view.serverNode.active = false
        if (this._sourceNode != null) {
            this._sourceNode.active = true
        }
    }


    @bindButtonClickEvent("btnTest15")
    onButtonTest15() {
        this.view.googleBillingNode.active = true
        this.view.testNode.active = false
        this.view.skuIdBox.string = "winner_product_1"
    }
    @bindButtonClickEvent("btnCloseGoogle")
    btnCloseGoogle() {
        this.view.googleBillingNode.active = false
        this.view.testNode.active = true
    }
    @bindButtonClickEvent("btnInitGoogle")
    btnInitGoogle() {
        GoogleBillingController.initBilling(true)
    }
    @bindButtonClickEvent("btnSearchSku")
    btnSearchSku() {
        let skuid: string = this.view.skuIdBox.string
        if (skuid.includes(";")) {
            let ss: string[] = skuid.split(";")
            GoogleBillingController.setSku(ss, null)
            GoogleBillingController.queryInventoryInApp()
        } else if (skuid != "") {
            GoogleBillingController.queryInventoryInApp(skuid)
        }
    }
    @bindButtonClickEvent("btnPurchase")
    btnPurchase() {
        if (this.view.skuIdBox.string != "") {
            GoogleBillingController.purchaseInApp(this.view.skuIdBox.string)
        }
    }
    @bindButtonClickEvent("btnOrder")
    btnOrder() {
        GoogleBillingController.queryPurchaseHistoryAsyncInApp()
    }
    @bindButtonClickEvent("btnHaveBuy")
    btnHaveBuy() {
        GoogleBillingController.queryPurchasesInApp()
    }
    @bindButtonClickEvent("btnSubSize")
    btnSubSize() {
        GoogleBillingController.getPurchasesSizeSubs()
    }
    @bindButtonClickEvent("btnOther1")
    btnOther1() {
        // this.getList()
        AppController.instance.showGoogleRewardAd("")
    }
    @bindButtonClickEvent("btnOther2")
    btnOther2() {
        // let self = this
        // IAPController.requestProduct()
        // cc.systemEvent.once("iapProductInfo", function (info) {
        //     self.view.skuIdBox.string = info
        // })
        // AppController.instance.sendNotification("测试title","测试message")
        // AppController.instance.requestEvaluate()
        let str = this.view.skuIdBox.string
        // let url = "https://play.google.com/store/apps/details?id=com.bigwin.dayingjia"  //market://details?id=com.bigwin.dayingjia
        // cc.sys.openURL(str)
        // "line://ti/p/@238hjrcl"   直接聊天
        //“line://R/nv/recommendOA"  将官方号分享给别人
        let e = AppController.instance.isAppExist(str)
        this.view.skuIdBox.string = e
    }
    @bindButtonClickEvent("btnOther3")
    btnOther3() {
        IAPController.clearAllParchased()
    }
    @bindButtonClickEvent("btnOther4")
    btnOther4() {
        // AppController.instance.showGoogleRewardAd("test")
        let str = this.view.skuIdBox.string
        AppController.instance.startApp(str)
    }

    onInit() {



    }

    onShow() {
        let self = this;
        cc.systemEvent.on("openinstallInstallCode", function (data) {
            if (data == "") {
                self.view.text.string = "没有参数";
            } else {
                self.view.text.string = data;
            }
        })
        this.serverInfo()
        this.view.serverNode.active = false
        this.view.messageNode.active = false
        let isDevelop = LoaclStorage.getNumber("__isDevelopTestMode", 0)
        if (isDevelop == 1) {
            this.view.verifyNode.active = false
            this.view.testNode.active = false
            this.view.demoNode.active = true
            this.view.messageNode.active = true
        } else if (isDevelop == 2) {
            this.view.verifyNode.active = false
            this.view.testNode.active = true
            this.view.demoNode.active = false
            this.view.messageNode.active = true
        }
        else {
            this.view.verifyNode.active = true
            this.view.testNode.active = false
            this.view.demoNode.active = false
        }
    }

    serverInfo() {
        let serverName = ""
        let mode = AppData.userConnectEnvi
        if (mode == 0) {
            serverName = "正式服"
        } else if (mode == 1) {
            serverName = "体验服"
        } else {
            serverName = "测试服"
        }
        this.view.serverLabel.string = ""
        this.view.serverUrlLabel.string = "当前服务器:" + serverName + "，地址：" + AppData.apiHttpUrl
    }

    serverInput() {
        let server = LoaclStorage.getString("gameDevelopServerHost", "")
        if (server == "") {
            let cacheServer = AppData.constHostDevelop
            if (cacheServer != "") {
                this.verifyCacheServerUrl(cacheServer)
            } else {
                if (this._sourceNode != null) {
                    this._sourceNode.active = false
                }
                this.view.serverNode.active = true
            }
        } else {
            AppData.constHostDevelop = server
            this.gobackLogin(this._loginMode)
        }

    }

    gobackLogin(mode) {
        AppData.userConnectEnvi = mode
        if (AppData.constHostDevelop == "" || AppData.constHostDevelop == "0") {
            AppData.userConnectEnvi = 0
        }
        GameManager.reset()
        LoaclStorage.setNumber("__userConnectEnvi", AppData.userConnectEnvi)
        AppData.setServerByData(mode)
        EventManager.instance.dispatch("hall_show_type", "HideHall", true)
        this.doScheduleOnce(() => {
            SceneManager.gotoAuth()
        }, 0.25)
    }

    verifyServerUrl(url) {
        if (url == "") {
            ModuleManager.instance.toast("请输入服务器地址");
        } else {
            let self = this
            let requestData: IHttpRequestData = {
                baseUrl: "https://api." + url + ":8088/api/getIp?",
                isApiRequest : false,
            }
            this.apiHttpGet(requestData, function (respone) {
                self.saveServerUrl(url)
            }, function (err) {
                ModuleManager.instance.toast("服务器地址错误，请重新输入");
            })
        }
    }

    getList() {
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "goods/list?",
            params: {
                goodsSource: "google_play",
                goodsType: "currency",
                // locale:
                pageNum: 1,
                pageSize: 6
            }
        }
        self.apiHttpGet(requestData, function (respone) {
            if (respone.data.length >= 1) {
                cc.log("获取到商品详情")
                let g = respone.data[0]
                self.eventBindOnce('googleBillingOnQueryReturn', function (data) {
                    let skud: string = data.SkuDetails
                    let skuDetails: string[] = skud.split("#@#")
                    for (let i = 0; i < skuDetails.length; i++) {
                        let t = JSON.parse(skuDetails[i])
                        self.eventBindOnce("googleBillingPurchaseSuccess", function (s) {
                            if (s.getPurchaseState == PurchaseState.PURCHASED) {
                                cc.log("购买成功,创建订单")
                            } else if (s.getPurchaseState == PurchaseState.PENDING) {
                                cc.log("等待支付")
                            }
                        })
                        GoogleBillingController.purchaseInApp(t.getSku)
                    }
                })
                GoogleBillingController.queryInventoryInApp(g.goodsCode)
            }
        }, function (err) {
            ModuleManager.instance.toast("服务器地址错误，请重新输入");
        })
    }


    verifyCacheServerUrl(url) {
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "https://api." + url + ":8088/api/getIp?",
            isApiRequest : false
        }
        GameUtil.http_get(requestData, function (respone) {
            LoaclStorage.setString("__customHostDevelop", url)
            self.gobackLogin(self._loginMode)
        }, function (err) {
            ModuleManager.instance.toast("缓存服务器地址错误，请重新输入");
            if (self._sourceNode != null) {
                self._sourceNode.active = false
            }
            self.view.serverNode.active = true
        })
    }


    saveServerUrl(url: string) {
        // url += ":8080"
        LoaclStorage.setString("__customHostDevelop", url)
        AppData.constHostDevelop = url
        if (this._sourceNode != null) {
            this._sourceNode.active = true
        }
        this.view.serverNode.active = false
        ModuleManager.instance.toast("服务器地址保存成功");
        this.gobackLogin(this._loginMode)
    }

    copyToken() {
        let loginUserID = LoaclStorage.getNumber("loginUserID", 0)
        let loginUserPassword = LoaclStorage.getString("loginUserPassword", "")
        let str: string = loginUserID + "@" + loginUserPassword
        AppController.instance.copyTextToClipboard(str)
        ModuleManager.instance.toast("token复制成功");
    }

    onHide() {
        this._clickTimes = 0
        // cc.systemEvent.off("openinstallInstallCode")
    }

    captureScreen(node, fn) {
        let self = this;
        let width = Math.floor(node.width);
        let height = Math.floor(node.height);
        if (CC_JSB) {
            let fileName = "result_share.jpg";
            let fullPath = jsb.fileUtils.getWritablePath() + fileName;
            if (jsb.fileUtils.isFileExist(fullPath)) {
                jsb.fileUtils.removeFile(fullPath);
            }
            let cameraNode = new cc.Node();
            cameraNode.parent = node.parent;
            let camera = cameraNode.addComponent(cc.Camera);
            camera.cullingMask = 0xffffffff;
            let texture = new cc.RenderTexture();
             //@ts-ignore
            let gl = cc.game._renderContext//cc.game._renderContext;
            texture.initWithSize(width, height, gl.STENCIL_INDEX8);
            camera.targetTexture = texture;
            camera.render(node);
            let data = texture.readPixels();
            //以下代码将截图后默认倒置的图片回正
            let picData = new Uint8Array(width * height * 4);
            let rowBytes = width * 4;
            for (let row = 0; row < height; row++) {
                let srow = height - 1 - row;
                let start = Math.floor(srow * width * 4);
                let reStart = row * width * 4;
                // save the piexls data
                for (let i = 0; i < rowBytes; i++) {
                    picData[reStart + i] = data[start + i];
                }
            }
            //保存图片
            jsb.saveImageData(picData, width, height, fullPath);
            cc.log("截图成功，图片保存在 ====>", fullPath);

            AppController.instance.saveImageToGallery(fullPath, "ceshi", "node")

            node.parent.removeChild(camera);
            if (fn) fn(fullPath);
        }
    }

}
